module.exports = __webpack_public_path__ + "static/media/avatar.a4574efb.jpg";